import { render, staticRenderFns } from "./passwordConfirmation.vue?vue&type=template&id=13fdec51"
import script from "./passwordConfirmation.vue?vue&type=script&lang=js"
export * from "./passwordConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports